/**
 * @generated SignedSource<<d8d285e84d98f2550da2b5c2f4376961>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentArticleAtomBase$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleHeadlineHeaderFeaturesContent" | "articleSeoArticle" | "articleShareWidgetArticle" | "bookmarkHeaderFeaturesContent" | "commentHeaderFeaturesArticle" | "contentShareWidgetContent" | "entityLinkHeaderFeaturesArticle" | "helpersCheckIsStyleArticle" | "helpersRosettaArticleContextArticle" | "helpersUseSharingUrl" | "hooksContentInterestArticle" | "hooksIsFreeArticleContent" | "hooksTrackPageViewArticle" | "hooksUseCurrentArticleIdsArticle" | "hooksUseCurrentArticlePrebidConfigArticle" | "hooksUsePageTargetingArticle" | "onboardingNewsletterSubscriptionArticle" | "shareHeaderFeaturesContent">;
  readonly " $fragmentType": "atomsCurrentArticleAtomBase";
};
export type atomsCurrentArticleAtomBase$key = {
  readonly " $data"?: atomsCurrentArticleAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentArticleAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentArticleAtomBase"
};

(node as any).hash = "4a1843f8dd17290ab5c197b002a8b8de";

export default node;
